import template from './floors-count.jade';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.floorsCount', []).directive('cianAfAboutBuildingFloorsCount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService, store) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.floorsMin = 1;
    this.floorsMax = 1000;

    this.validation = validation(this.form, 'building.floorsCount', {
      parse: 'Введите число',
      required: 'Введите количество этажей',
      min: `Количество этажей не может быть меньше ${this.floorsMin}`,
      max: 'Допустимо не более 3 символов',
    });

    let trackedValue;

    this.handleBlur = () => {
      const value = this.ad.building.floorsCount;

      if (value && value !== trackedValue) {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'number_of_floors');
        trackedValue = value;
      }
    };
  },
  controllerAs: 'floorsCount',
  template,
})).name;
